import Vue from 'vue'
import App from './App.vue'
import router from './router'
import reveal from './directives/reveal'
import { applyRouteSeo } from './utils/seo'
import './assets/css/portal.css'
import './assets/css/rich-content.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

Vue.directive('reveal', reveal)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  mounted() {
    applyRouteSeo(this.$route)
  }
}).$mount('#app')
